import { motion, Variants } from "framer-motion";
import CatLoader from "../../Loading/CatLoader";
import { LoadingState } from "../useOnClick";

interface Props {
  childrenVariants: Variants;
  loading: LoadingState;
}

export default function LoadingOverlayContent({
  childrenVariants,
  loading,
}: Props) {
  return (
    <div className="flex min-h-full items-center justify-center">
      {loading !== false && (
        <motion.div
          key="loader"
          variants={childrenVariants}
          className="w-5/6 md:w-96"
        >
          <CatLoader theme="white" ready={loading === "ready"} />
        </motion.div>
      )}
    </div>
  );
}
